import { render, staticRenderFns } from "./seller-note.vue?vue&type=template&id=4952693d&"
import script from "./seller-note.vue?vue&type=script&lang=ts&"
export * from "./seller-note.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports